<div class="messsages-panel">
    <p *ngFor="let m of messages; let i = index">
        <ngb-alert [type]="getMessageType(m.type)" [ngClass]="(i == (messages.length - 1)) ? 'last' : 'old' " (close)="close(m)">{{ m.msg }}</ngb-alert>
    </p>
</div>